module.exports = __webpack_public_path__ + "img/hyqy_icon.0e134643.svg";